import { DEFAULT_PAGINATION } from '../../../../../common/query/defaults'
import { ExternalTransactionListQuery, TransactionLogListQuery } from './query.types'
import { IExternalTransactionsFilters } from './types'

export const DEFAULT_EXTERNAL_TRANSACTION_QUERY: ExternalTransactionListQuery = {
  ...DEFAULT_PAGINATION,
  perPage: 20,
}

export const DEFAULT_TRANSACTION_LOG_QUERY: Omit<TransactionLogListQuery, 'external_transaction_id'> = {
  ...DEFAULT_PAGINATION,
  perPage: 100,
}

export const DEFAULT_EXTERNAL_TRANSACTIONS_FILTERS: IExternalTransactionsFilters = {
  searchAdvanced: { field: 'ticketToken', query: '' },
  paymentAdapterId: '',
  provider: '',
}
